export default __webpack_public_path__ + "3794d7c8ba07b13fb3c6d9c742e873aa.png";